import axios from 'axios';

export default {
  login(credentials) {
    return axios.post('/v1/login', credentials);
  },
  loginOptima(credentials) {
    return axios.post('/v2/login/redirect', credentials);
  },
  createUser(data) {
    return axios.post('/v1/users', data);
  },
  create(data) {
    return axios.post('/v1/user-with-profile', data);
  },
  listProfile() {
    return axios.get('/v1/profile/list-profile');
  },
  getAll(params = {}) {
    return axios.get('/v1/user/list-user', { params });
  },
  detail({ id }) {
    return axios.get(`/v1/user/detail/${id}`);
  },
  update(id, params) {
    return axios.post(`/v1/user/update/${id}`, params);
  },
  getRoleConfig(params) {
    return axios.get('/v1/list-role-new', { params });
  },
  changePassword(params) {
    return axios.post('/v1/user/updatePassword', params);
  },
  resetPassword(email) {
    return axios.post('/v1/forgot-password', email);
  },
  createPassword(token, params) {
    return axios.post(`/v1/reset-password/${token}`, params);
  },
  getCompability() {
    return axios.get('/v1/compability-password');
  },
  getCompabilityCheck() {
    return axios.get('/v1/compability-password/check');
  },
  updateCompability(days) {
    return axios.patch('/v1/compability-password', days);
  },
  updateStatus(id, paramsUser) {
    return axios.post(`/v1/update-active/${id}`, paramsUser);
  }
};
